module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/public/public.component.scss
// module id = ./src/app/public/public.component.scss
// module chunks = main